const topLeftLng = 103.78595945422515;
const topLeftLat = 1.2976129210499472;
const imageRatio = 2000 / 4267;
const widthInGIS = 0.0011181175118634928;
const heightInGIS = widthInGIS * imageRatio;

export const mapboxToken =
  "pk.eyJ1IjoiaGFuc2NhdSIsImEiOiJjbHdsbTEwcmMxa2cyMmxxbXEzdmN5MHcxIn0.Nrir4FxZEOlwCLmxgPpICQ";

export const OVERLAY_APPEND_KEY = "-overlay";
export const DEFAULT_WIDTH_GIS = widthInGIS